<template>
  <div>
    <v-row v-if="$vuetify.breakpoint.width < 960">
      <v-menu v-model="emojiMenu" offset-y top>
        <template v-slot:activator="{ attrs, on }">
          <v-btn plain v-bind="attrs" v-on="on" style="min-width: 36px">
            <span style="font-size: 17px; font-weight: 500" class="material-icons-round white--text" translate="no">
              {{ emojiMenu ? 'close' : 'emoji_emotions' }}
            </span>
          </v-btn>
        </template>
        <div class="" style="background-color: #1d292f; overflow: hidden">
          <v-row align="center" justify="center" dense style="height: 50px">
            <v-col
              v-for="(item, i) in feedbackEmoji"
              :key="i"
              cols="auto"
              :class="item.value ? 'px-2 py-1 mr-2 item-emoji-feedback is-value' : 'px-2 py-1 mr-2 item-emoji-feedback'"
            >
              <v-tooltip color="#131b1e" top nudge-top="5">
                <template v-slot:activator="{ on }">
                  <v-btn
                    plain
                    @click="clickEmoji(i)"
                    small
                    height="10"
                    width="20"
                    min-width="20"
                    dark
                    v-on="on"
                    :class="{ 'disable-events': isLoading }"
                  >
                    <fluent-emoji-check-mark-button
                      v-if="item.unicode == 'U+2705'"
                      size="15"
                      class="mr-1"
                    ></fluent-emoji-check-mark-button>
                    <fluent-emoji-clapping-hands
                      v-if="item.unicode == 'U+1F44F'"
                      size="15"
                      class="mr-1"
                    ></fluent-emoji-clapping-hands>
                    <fluent-emoji-red-heart
                      v-if="item.unicode == 'U+2764'"
                      size="15"
                      class="mr-1"
                    ></fluent-emoji-red-heart>
                    <fluent-emoji-eyes v-if="item.unicode == 'U+1F440'" size="15" class="mr-1"></fluent-emoji-eyes>
                    {{ item.count }}
                  </v-btn>
                </template>
                <span v-if="!item.user.length && item.unicode == 'U+2705' && !isLoading">
                  {{ 'Be the first one to react with ✅' }}
                </span>
                <span v-else-if="!item.user.length && item.unicode == 'U+1F44F' && !isLoading">
                  {{ 'Be the first one to react with 👋' }}
                </span>
                <span v-else-if="!item.user.length && item.unicode == 'U+2764' && !isLoading">
                  {{ 'Be the first one to react with ❤️' }}
                </span>
                <span v-else-if="!item.user.length && item.unicode == 'U+1F440' && !isLoading">
                  {{ 'Be the first one to react with 👀' }}
                </span>
                <span v-else-if="!isLoading">
                  <div>
                    <span v-for="(userItem, j) in item.user" :key="j">
                      {{ j == item.user.length - 1 ? userItem.name : userItem.name + ', ' }}
                    </span>
                  </div>
                  <div>
                    <span>{{ ' reacted with ' }}</span>
                    <span v-if="item.unicode == 'U+2705'">{{ '✅' }}</span>
                    <span v-else-if="item.unicode == 'U+1F44F'">{{ '👋' }}</span>
                    <span v-else-if="item.unicode == 'U+2764'">{{ '❤️' }}</span>
                    <span v-else-if="item.unicode == 'U+1F440'">{{ '👀' }}</span>
                  </div>
                </span>
              </v-tooltip>
            </v-col>
          </v-row>
        </div>
      </v-menu>
    </v-row>
    <v-row v-else align="start" no-gutters style="" class="container-emoji-feedback">
      <v-col
        v-for="(item, i) in feedbackEmoji"
        :key="i"
        cols="auto"
        :class="item.value ? 'px-2 py-1 mr-2 item-emoji-feedback is-value' : 'px-2 py-1 mr-2 item-emoji-feedback'"
      >
        <v-tooltip color="#131b1e" top nudge-top="5">
          <template v-slot:activator="{ on }">
            <v-btn
              plain
              @click="clickEmoji(i)"
              small
              height="10"
              width="20"
              min-width="20"
              dark
              v-on="on"
              :class="{ 'disable-events': isLoading }"
            >
              <fluent-emoji-check-mark-button
                v-if="item.unicode == 'U+2705'"
                size="15"
                class="mr-1"
              ></fluent-emoji-check-mark-button>
              <fluent-emoji-clapping-hands
                v-if="item.unicode == 'U+1F44F'"
                size="15"
                class="mr-1"
              ></fluent-emoji-clapping-hands>
              <fluent-emoji-red-heart v-if="item.unicode == 'U+2764'" size="15" class="mr-1"></fluent-emoji-red-heart>
              <fluent-emoji-eyes v-if="item.unicode == 'U+1F440'" size="15" class="mr-1"></fluent-emoji-eyes>
              {{ item.count }}
            </v-btn>
          </template>
          <span v-if="!item.user.length && item.unicode == 'U+2705' && !isLoading">
            {{ 'Be the first one to react with ✅' }}
          </span>
          <span v-else-if="!item.user.length && item.unicode == 'U+1F44F' && !isLoading">
            {{ 'Be the first one to react with 👋' }}
          </span>
          <span v-else-if="!item.user.length && item.unicode == 'U+2764' && !isLoading">
            {{ 'Be the first one to react with ❤️' }}
          </span>
          <span v-else-if="!item.user.length && item.unicode == 'U+1F440' && !isLoading">
            {{ 'Be the first one to react with 👀' }}
          </span>
          <span v-else-if="!isLoading">
            <div>
              <span v-for="(userItem, j) in item.user" :key="j">
                {{ j == item.user.length - 1 ? userItem.name : userItem.name + ', ' }}
              </span>
            </div>
            <div>
              <span>{{ ' reacted with ' }}</span>
              <span v-if="item.unicode == 'U+2705'">{{ '✅' }}</span>
              <span v-else-if="item.unicode == 'U+1F44F'">{{ '👋' }}</span>
              <span v-else-if="item.unicode == 'U+2764'">{{ '❤️' }}</span>
              <span v-else-if="item.unicode == 'U+1F440'">{{ '👀' }}</span>
            </div>
          </span>
        </v-tooltip>
      </v-col>
    </v-row>
    <guest-in v-if="guestInVisible" @close="closeGuestIn" :guestInVisible.sync="guestInVisible"></guest-in>
  </div>
</template>

<script>
import Toast from '@/views/meeting/component/Toast'
import { mapGetters } from 'vuex'
import GuestIn from '@/views/modal/GuestIn'
import FluentEmojiCheckMarkButton from '@/views/meeting/component/emoji/FluentEmojiCheckMarkButton'
import FluentEmojiClappingHands from '@/views/meeting/component/emoji/FluentEmojiClappingHands'
import FluentEmojiEyes from '@/views/meeting/component/emoji/FluentEmojiEyes'
// import FluentEmojiThinkingFace from '@/views/meeting/component/emoji/FluentEmojiThinkingFace'
import FluentEmojiRedHeart from '../emoji/FluentEmojiRedHeart.vue'
import { setCreateEmoji, setDeleteEmoji, getEmojiList } from '@/services/emoji'

export default {
  name: 'DetailEmojiFeedback',
  components: {
    GuestIn,
    FluentEmojiClappingHands,
    FluentEmojiCheckMarkButton,
    // FluentEmojiThinkingFace,
    FluentEmojiEyes,
    FluentEmojiRedHeart,
  },
  props: ['sectionIndex', 'sectionClipIndex', 'feedbackPageEmoji'],
  data() {
    return {
      countedEmojiList: [
        {
          unicode: 'U+2705',
          emojiName: 'Check Mark',
          count: 0,
          value: false,
          id: null,
          uniqueValue: [],
          user: [],
          self: '',
        },
        {
          unicode: 'U+1F44F',
          emojiName: 'Clapping Hands',
          count: 0,
          value: false,
          id: null,
          uniqueValue: [],
          user: [],
          self: '',
        },
        {
          unicode: 'U+2764',
          emojiName: 'Red Heart',
          count: 0,
          value: false,
          id: null,
          uniqueValue: [],
          user: [],
          self: '',
        },
        {
          unicode: 'U+1F440',
          emojiName: 'Eyes',
          count: 0,
          value: false,
          id: null,
          uniqueValue: [],
          user: [],
          self: '',
        },
      ],
      feedbackEmojiList: [],
      emojiList: [],
      isLoading: false,
      guestInVisible: false,
      temporaryEmoji: { unicode: '', val: '' },
      emojiMenu: false,
    }
  },
  methods: {
    emojiUserNames(val) {
      return val.slice(0, 3).join(', ')
    },
    getEmojiCount() {
      if (!this.feedbackEmojiList) {
        for (let i = 0; i < this.countedEmojiList.length; i++) {
          this.countedEmojiList[i].count = 0
          this.countedEmojiList[i].value = false
        }
        return
      }

      for (let j = 0; j < this.countedEmojiList.length; j++) {
        this.countedEmojiList[j].uniqueValue = []
        this.countedEmojiList[j].user = []

        this.countedEmojiList[j].count = this.feedbackEmojiList.filter(
          (x) => x.unicode == this.countedEmojiList[j].unicode
        ).length

        this.countedEmojiList[j].uniqueValue = this.feedbackEmojiList.filter(
          (x) => x.unicode == this.countedEmojiList[j].unicode
        )
      }

      for (let i = 0; i < this.countedEmojiList.length; i++) {
        for (let j = 0; j < this.countedEmojiList[i].uniqueValue.length; j++) {
          this.countedEmojiList[i].user.push({
            id: this.countedEmojiList[i].uniqueValue[j].userInfo.userId,
            name:
              this.countedEmojiList[i].uniqueValue[j].userInfo.userDisplayName ||
              this.countedEmojiList[i].uniqueValue[j].userInfo.userFullName,
          })
        }
      }
    },
    clickEmoji(val) {
      let unicode
      switch (val) {
        case 0:
          unicode = 'U+2705'
          break
        case 1:
          unicode = 'U+1F44F'
          break
        case 2:
          unicode = 'U+2764'
          break
        case 3:
          unicode = 'U+1F440'
          break
      }
      if (
        this.chkMtPublic &&
        this.chkMtPublic['isPublic'] &&
        (!this.currentUser.userId || this.currentUser.userId === null)
      ) {
        this.guestInActionType = 'guestEmoji'
        this.guestInVisible = true
        this.temporaryEmoji.unicode = unicode
        this.temporaryEmoji.val = val
      } else {
        if (this.feedbackEmoji[val].value) {
          if (this.serverCommu) return
          this.setDeleteEmoji(this.feedbackEmoji[val].id, this.feedbackEmoji[val].unicode, val)
        } else {
          if (this.serverCommu) return
          this.setCreateEmoji(unicode, val)
        }
      }
      // this.$emit('emojiList', { data1: this.emojiList, data2: this.countedEmojiList })
    },
    getEmojivalue() {
      if (!this.userInfo) return

      let valueedEmojiList = this.feedbackEmojiList.filter((x) => x.userId == this.userInfo.userId)
      for (let j = 0; j < this.countedEmojiList.length; j++) {
        this.countedEmojiList[j].value = false
      }

      for (let i = 0; i < valueedEmojiList.length; i++) {
        for (let j = 0; j < this.countedEmojiList.length; j++)
          if (valueedEmojiList[i].unicode == this.countedEmojiList[j].unicode) {
            this.countedEmojiList[j].value = true
            this.countedEmojiList[j].id = valueedEmojiList[i].emojiId
          }
      }
    },
    async setCreateEmoji(unicode, val) {
      this.isLoading = true
      this.$store.dispatch('setServerCommu', true)
      this.feedbackEmoji[val].count += 1
      this.feedbackEmoji[val].value = true
      this.feedbackEmoji[val].user.unshift({
        id: this.userInfo.userId,
        name: this.userInfo.userDisplayName || this.userInfo.userFullName,
      })
      try {
        let response = await setCreateEmoji(this, this.currentClip.clipId, unicode, 'feedback', 0, 0, 0)
        if (response) {
          this.$store.dispatch('setFirebaseLog', {
            eventName: 'create_clip_emoji',
            eventParam: {
              name: 'create_clip_emoji',
            },
          })
          for (let i = 0; i < this.feedbackEmoji.length; i++)
            if (this.feedbackEmoji[i].unicode == response.unicode) {
              this.feedbackEmoji[i].id = response.emojiId
            }
        }
      } catch (error) {
        // notify(this, 'Error', this.$t('setEmojiError'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('setEmojiError'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        this.feedbackEmoji[val].count -= 1
        this.feedbackEmoji[val].value = false
        for (let i = 0; i < this.feedbackEmoji[val].user.length; i++)
          if (this.feedbackEmoji[val].user[i].userId == this.userInfo.userId) {
            this.feedbackEmoji[val].user[i].splice(i, 1)
          }
        console.log(error)
      } finally {
        this.$store.dispatch('setFeedbackEmoji', this.feedbackEmoji)
        this.isLoading = false
        this.$store.dispatch('setServerCommu', false)
      }
    },
    async setDeleteEmoji(id, unicode, val) {
      this.isLoading = true
      this.$store.dispatch('setServerCommu', true)
      this.feedbackEmoji[val].count -= 1
      this.feedbackEmoji[val].value = false
      for (let i = 0; i < this.feedbackEmoji[val].user.length; i++)
        if (this.feedbackEmoji[val].user[i].id == this.userInfo.userId) {
          this.feedbackEmoji[val].user.splice(i, 1)
        }
      try {
        let response = await setDeleteEmoji(this, this.currentClip.clipId, id, 'emoji')
        if (response == 'success') {
          this.$store.dispatch('setFirebaseLog', {
            eventName: 'delete_clip_emoji',
            eventParam: {
              name: 'delete_clip_emoji',
            },
          })
          for (let i = 0; i < this.feedbackEmoji.length; i++)
            if (this.feedbackEmoji[i].unicode == unicode) {
              this.feedbackEmoji[i].id = null
            }
        }
      } catch (error) {
        // notify(this, 'Error', this.$t('deleteEmojiError'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('deleteEmojiError'),
            // submsg: '',
          },
        }
        this.$toast.error(content)

        this.feedbackEmoji[val].count += 1
        this.zv[val].value = true
        this.feedbackEmoji[val].user.unshift({
          id: this.userInfo.userId,
          name: this.userInfo.userDisplayName || this.userInfo.userFullName,
        })
        console.log(error)
      } finally {
        this.$store.dispatch('setFeedbackEmoji', this.feedbackEmoji)
        this.isLoading = false
        this.$store.dispatch('setServerCommu', false)
      }
    },
    async getEmojiList() {
      try {
        let result = await getEmojiList(this, this.currentClip.clipId)
        this.emojiList = result
        this.feedbackEmojiList = result.feedbackList
      } catch (error) {
        console.log(error)
      } finally {
        if (this.feedbackEmojiList) {
          this.getEmojiCount()
          this.getEmojivalue()
        }
        this.$store.dispatch('setFeedbackEmoji', this.countedEmojiList)
        this.isLoading = false
      }
    },
    closeGuestIn() {
      this.guestInVisible = false
      if (this.currentUser && !isEmptyObject(this.currentUser)) {
        this.setCreateEmoji(this.temporaryEmoji.unicode, this.temporaryEmoji.val)
        this.temporaryEmoji.unicode = ''
        this.temporaryEmoji.val = ''
      }
      function isEmptyObject(param) {
        return Object.keys(param).length === 0 && param.constructor === Object
      }
    },
  },
  computed: {
    mtInfo() {
      return this.$store.getters.currentMt
    },
    currentUser() {
      let user = this.$store.getters.userInfo
      return user && user !== null ? user : {}
    },
    ...mapGetters(['feedbackEmoji', 'serverCommu', 'chkMtPublic', 'clipIndex', 'userInfo', 'currentClip']),
  },
  watch: {
    clipIndex() {
      if (this.feedbackEmoji) {
        for (let i = 0; i < this.feedbackEmoji.length; i++) {
          this.feedbackEmoji[i].count = 0
          this.feedbackEmoji[i].value = false
        }
      }
    },
    currentClip() {
      if (this.feedbackEmoji && this.feedbackEmoji.length > 0) {
        for (let i = 0; i < this.feedbackEmoji.length; i++) {
          this.feedbackEmoji[i].count = 0
          this.feedbackEmoji[i].value = false
        }
      }
    },
    sectionIndex() {
      for (let i = 0; i < this.feedbackEmoji.length; i++) {
        this.feedbackEmoji[i].count = 0
        this.feedbackEmoji[i].value = false
      }
    },
    guestInVisible(val) {
      this.$store.dispatch('setIsGuestVisible', val)
    },
  },
}
</script>

<style scoped>
.container-emoji-feedback {
  background-color: transparent;
  height: 22px;
  color: #bbb;
  font-size: 11px;
  vertical-align: middle;
}
.item-emoji-feedback {
  /* background-color: rgb(20, 35, 42); */
  border-radius: 5px;
  border: 1px solid transparent;
  transition: all 0.3s;
}
.item-emoji-feedback:hover {
  /* border: 1px solid rgba(10, 14, 16, 1); */
  background-color: rgb(33, 52, 59);
  transition: all 0.3s;
}
.disable-events {
  pointer-events: none;
}
.item-emoji-feedback div {
  vertical-align: middle;
  position: relative;
  top: -1px;
}
.is-value {
  background-color: #289067;
}
button >>> span {
  font-weight: 400;
}
</style>
